/**
 * AI CONTEXT
 * Purpose: tiny wrapper for titled blocks inside timeline/tooltips.
 * Used by: SessionStripeTooltip and SessionAttendanceDetails.
 * Importance: keeps tooltip layouts consistent and lightweight.
 * Refactor: optional className prop for easier style extension.
 */
import { ReactNode } from "react"

const TooltipBlock = ({
  title,
  children,
}: {
  title?: string
  children: ReactNode
}) => {
  return (
    <div>
      {title && <h4>{title}</h4>}
      {children}
    </div>
  )
}

export default TooltipBlock
